export const REQUEST_FOR_FINANCIAL_ARTICLES_ITEM =
  'REQUEST_FOR_FINANCIAL_ARTICLES_ITEM';
export const GET_FINANCIAL_ARTICLES_ITEM_SUCCESS =
  'GET_FINANCIAL_ARTICLES_ITEM_SUCCESS';
export const GET_FINANCIAL_ARTICLES_ITEM_ERROR =
  'GET_FINANCIAL_ARTICLES_ITEM_ERROR';
